import i18next from 'i18next';
import React, { useState } from 'react';

import { Checkbox } from '@commons/utils/styledLibraryComponents';
import Text, { ENUM_COLORS } from '@commons/Text';

import { Action, ActionsContainer, Button, Container, Icon } from './styledComponents';

const OrderParams = (props) => {
  const {
    multipleOrder,
    setMultipleOrder,
    displayUnavailableProductOrders,
    canConfigureStefOrderAvailability,
    displayModalStefCredentialsEdition,
    setDisplayUnavailableProductOrders,
    xlsWithOrder,
    setXlsWithOrder,
    canIncludeExcelInOrderMail,
    isAllowedToUpdate,
    hidePrices,
    setHidePrices,
    displayAmountInclTaxesInPurchaseOrder,
    setDisplayAmountInclTaxesInPurchaseOrder,
    allowDecimalQuantitiesOrder,
    setAllowDecimalQuantitiesOrder,
    hasEdi,
    setHasEdi,
    userHasRoleInpulse,
  } = props;

  const [shouldDisplayActions, setShouldDisplayActions] = useState(false);

  /**
   * Handle callback to trigger the display of actions dropdown
   */
  const triggerDropdown = () => {
    setShouldDisplayActions(!shouldDisplayActions);
  };

  /**
   * Handle render of dropdown actions
   */
  const renderDropdownActions = () => {
    if (!shouldDisplayActions) {
      return <></>;
    }

    return (
      <ActionsContainer canIncludeExcelInOrderMail={canIncludeExcelInOrderMail}>
        <Action onClick={() => isAllowedToUpdate && setMultipleOrder(!multipleOrder)}>
          <Checkbox
            isChecked={multipleOrder}
            isDisabled={!isAllowedToUpdate}
            shape={'square'}
            noSize
          />
          <Text>
            {i18next.t(
              'ADMIN.SUPPLIERS.SUPPLIER_DETAIL_ORDER_TOGGLE_MULTIPLE_ORDER_SAME_DATE_TEXT',
            )}
          </Text>
        </Action>
        <Action
          onClick={() =>
            isAllowedToUpdate &&
            setDisplayUnavailableProductOrders(!displayUnavailableProductOrders)
          }
        >
          <Checkbox
            isChecked={displayUnavailableProductOrders}
            isDisabled={!isAllowedToUpdate}
            shape={'square'}
            noSize
          />
          <Text>
            {i18next.t(
              'ADMIN.SUPPLIERS.SUPPLIER_DETAIL_ORDER_TOGGLE_DISPLAY_UNAVAILABLE_PRODUCT_ORDERS',
            )}
          </Text>
        </Action>
        <Action
          onClick={() =>
            isAllowedToUpdate && setAllowDecimalQuantitiesOrder(!allowDecimalQuantitiesOrder)
          }
        >
          <Checkbox
            isChecked={allowDecimalQuantitiesOrder}
            isDisabled={!isAllowedToUpdate}
            shape={'square'}
            noSize
          />
          <Text>{i18next.t('ADMIN.SUPPLIERS.SUPPLIER_DETAIL_ORDER_TOGGLE_DECIMALS')}</Text>
        </Action>
        {canIncludeExcelInOrderMail && (
          <>
            <Action onClick={() => isAllowedToUpdate && !hasEdi && setXlsWithOrder(!xlsWithOrder)}>
              <Checkbox
                isChecked={xlsWithOrder}
                isDisabled={!isAllowedToUpdate || hasEdi}
                shape={'square'}
                noSize
              />
              <Text>
                {i18next.t('ADMIN.SUPPLIERS.SUPPLIER_DETAIL_ORDER_TOGGLE_XLS_WITH_ORDER_MAIL')}
              </Text>
            </Action>
            <Action onClick={() => isAllowedToUpdate && !hasEdi && setHidePrices(!hidePrices)}>
              <Checkbox
                isChecked={hidePrices}
                isDisabled={!isAllowedToUpdate || hasEdi}
                shape={'square'}
                noSize
              />
              <Text>{i18next.t('ADMIN.SUPPLIERS.SUPPLIER_DETAIL_ORDER_TOGGLE_HIDE_PRICES')}</Text>
            </Action>
          </>
        )}
        {canConfigureStefOrderAvailability && (
          <Action isHighlighted onClick={displayModalStefCredentialsEdition}>
            <Text color={ENUM_COLORS.LIGHTEST}>
              {i18next.t('ADMIN.SUPPLIERS.SUPPLIER_DETAIL_STEF_ORDER_AVAILABILITY_CONFIGURATION')}
            </Text>
          </Action>
        )}
        <Action
          onClick={() =>
            isAllowedToUpdate &&
            setDisplayAmountInclTaxesInPurchaseOrder(!displayAmountInclTaxesInPurchaseOrder)
          }
        >
          <Checkbox
            isChecked={displayAmountInclTaxesInPurchaseOrder}
            isDisabled={!isAllowedToUpdate}
            shape={'square'}
            noSize
          />
          <Text>
            {i18next.t(
              'ADMIN.SUPPLIERS.SUPPLIER_DETAIL_ORDER_TOGGLE_DISPLAY_AMOUNT_INCL_TAXES_IN_PURCHASE_ORDER',
            )}
          </Text>
        </Action>
        {(!hasEdi && !userHasRoleInpulse && <></>) || (
          <Action onClick={() => userHasRoleInpulse && setHasEdi(!hasEdi)}>
            <Checkbox isChecked={hasEdi} isDisabled={!userHasRoleInpulse} shape={'square'} noSize />
            <Text>{i18next.t('ADMIN.SUPPLIERS.SUPPLIER_DETAIL_ORDER_TOGGLE_HAS_EDI')}</Text>
          </Action>
        )}
      </ActionsContainer>
    );
  };

  return (
    <Container>
      <Button onClick={triggerDropdown}>
        <Icon alt="order-params-button" src={'/images/inpulse/settings.svg'} />
      </Button>
      {renderDropdownActions()}
    </Container>
  );
};

export default OrderParams;
